export enum ProviderState {
  Active = 1,
  Inactive = 2
};